$(document).on ( 'areaReady', function(event) {
    $( 'form' , event.target ).each ( function () {
        $( this ).append ( '<input type="hidden" name="token" value="' + CSRF_TOKEN + '">' );
    } ) ;

    $( 'a.js-add-csrf', event.target ).each ( function () {
        if ( this.href.match ( /\?/ ) == null ) {            
            this.href = this.href + '?token=' + CSRF_TOKEN ;            
        } else {
            this.href = this.href + '&token=' + CSRF_TOKEN ;            
        }
    } ) ;
});